import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { EmspUserInvoiceBaseModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/emsp-user-invoice-base.model';
import { CellContext } from '@tanstack/react-table';

export interface EmspBoInvoiceListEmspUserIdCellProps
  extends CellContext<
    EmspUserInvoiceBaseModel,
    EmspUserInvoiceBaseModel['emspUser']['id']
  > {}

export const EmspBoInvoiceListEmspUserIdCell = (
  props: EmspBoInvoiceListEmspUserIdCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <Text truncate>{getValue() ?? '-'}</Text>;
};
